"use client"

// src/components/link.ts
var Link = {
  baseStyle: {
    color: "link",
    cursor: "pointer",
    outline: "none",
    textDecoration: "none",
    transitionDuration: "fast",
    transitionProperty: "common",
    transitionTimingFunction: "ease-out",
    _focusVisible: {
      boxShadow: "outline"
    },
    _hover: {
      textDecoration: "underline"
    }
  }
};

export {
  Link
};
//# sourceMappingURL=chunk-PBZCCVBS.mjs.map